import theme, { colors } from '@globals/themes/defaultTheme'
import DesktopDialogWithMobileDrawer from '@shared/dialog/DesktopDialogWithMobileDrawer'
import LicensingDialogContent from './LicensingDialogContent'

export const LICENSING_DIALOG_KEY = 'licensingDialogKey'

const paywallDrawerStyle = { zIndex: theme.zIndex.modal + 1 }

const LicensingDialog: React.FC = () => {
  return (
    <DesktopDialogWithMobileDrawer
      showTitle={false}
      maxDialogWidth="md"
      dialogKey={LICENSING_DIALOG_KEY}
      backgroundColor={colors.white}
      drawerStyles={paywallDrawerStyle}>
      <LicensingDialogContent />
    </DesktopDialogWithMobileDrawer>
  )
}

export default LicensingDialog
